<template>
    <div>
    <vs-progress :percent="Number(params.data.participation_presance/params.data.participation_total*100)" :color="getPopularityColor(Number(params.data.participation_presance/params.data.participation_total*100))" />
    </div>
</template>

<script>
    export default {
        name: 'CellRendererVerified',
        computed: {
          textColor() {
            return this.params.value ? "text-primary" : "text-grey"
          },
          
        },
        
    methods:{
        getPopularityColor(num) {
      if(num > 90) return "success"
      if(num >70) return "primary"
      if(num >= 50) return "warning"
      if(num < 50) return "danger"
      return "primary"
    },
    }
    }
</script>
